export enum BracketType {
  DIAGONAL = 'diagonal_bracket',
  L = 'l_bracket',
  L_WITH_DIAGONAL = 'l_with_diagonal_bracket',
}
